import React, { createContext, useEffect, useState } from 'react';
import { getempDetails } from '../../components/inboundCenter';
import { get_ak } from './emploginService';
import getCookie, { setCookie } from '../GetCookie/getCookie';

const EmployeeContext = createContext();

export const EmployeeProvider = ({ children }) => {
  const [employeeDetails, setEmployeeDetails] = useState(null);
  const urlParams = new URLSearchParams(window.location.search);
  const empid = urlParams.get('empid');
  const ONum = urlParams.get('origNum') || "";
  const phone = urlParams.get('phone') || "";
  const ucid = urlParams.get('crtObjectId') || "";
  const type = urlParams.get('type') || "";

  useEffect(() => {
      if (!empid) return; // If empid is not available, return

      async function fetchEmployeeDetails() {
          try {
              let ak = getCookie("jwt_token");
              let empAK;
              if(!ak){
                window.location.href = window.location.origin
              }
              if (ak || empAK) {
                  let data = await getempDetails(empid, ak || empAK);
                  data['ak'] = ak || empAK;
                  data['empid'] = empid;
                  data['ONum'] = ONum || phone;
                  data['ucid'] = ucid;
                  data['type'] = type;
                  setCookie("employeeData", JSON.stringify(data));
                  setEmployeeDetails(data);
              }
          } catch (error) {
              console.error('Error fetching employee details:', error);
          }
      }

      fetchEmployeeDetails();
  }, [empid, ONum, phone]); 

  return (
    <EmployeeContext.Provider value={employeeDetails}>
      {children}
    </EmployeeContext.Provider>
  );
};

export default EmployeeContext;
